import './modal-open-class.scss';

//react
import { useState, useRef, useEffect } from 'react';
import { useMutation } from '@apollo/client';
//shared
import Modal from '../modal-alert/modal-alert';
import { ADD_CLOSE_QUOTAS, CLASSES_BRANCH } from '../../graphql/branch';
import Message from '../message/message';
import { MESSAGE_ADD_QUOTAS } from '../../../class-branch/constants/messages';
//material
import { Button } from '@mui/material';
import Icon from '../icon/icon';
 
export const ModalOpenClass = ({ calendarId, availableSpace }: { calendarId: number, availableSpace: number }) => {

  let [estatusModal, changeStateModal] = useState(false);

  const [ActiveQuotas, { data, loading, error, reset }] = useMutation(ADD_CLOSE_QUOTAS, {
    variables: {
      userId: null,
      calendarId: calendarId,
      close: false,
      quotas: availableSpace,
    },
    refetchQueries: [CLASSES_BRANCH]
  });
  let message = MESSAGE_ADD_QUOTAS;
  message.open = useRef<any>(null);

  if (data) {
    message.textMessage = data.AddAndCloseQuotas.message;
    message.style = data.AddAndCloseQuotas.success ? 'success' : 'danger';
    setTimeout(() => {
      message.open.current.show();
    }, 500);
    reset();
  }

  const [windowWidth, setWindowWidth] = useState(window.innerWidth);

  useEffect(() => {
    const handleResize = () => {
      setWindowWidth(window.innerWidth);
    };

    window.addEventListener('resize', handleResize);

    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  if (error) console.log(`Submission error! ${error.message}`);

  return (
    <div className="modal-open-class">
      {/* <CheckCircleIcon className='checkIcon' onClick={() => changeStateModal(!estatusModal)} /> */}

      <Button disabled={loading} className={`btn-open-class ${windowWidth <= 860 ? ' btn-action-mobilee' : ''}`} onClick={() => changeStateModal(!estatusModal)}>
        {/* {windowWidth >= 601 && (<span> Habilitar clase</span>)}
        {windowWidth <= 600 && (
          <>
            <Icon width='20' height='19' name='check'></Icon>
            <span>Habilitar clase</span>
          </>
        )} */}
        Habilitar clase
      </Button>

      <Modal
        estatus={estatusModal}
        changeStatus={estatusModal}
        showHeader={false}
        buttonCancel={false}
        classNameModal='class-modal-open-class'
      >
        <div className='content'>
          <div className="content-body">
            <Icon width='75' height='75' name='person-warning' color='#00195e'></Icon>
            <h3>¡Alto!</h3>
            <p>
              ¿Estas seguro que quieres habilita la clase?
            </p>

            <div className='buttons'>
              <Button className='ok-button' disabled={loading} onClick={() => {
                ActiveQuotas({
                  variables: {
                    userId: null,
                    calendarId: calendarId,
                    close: false,
                    quotas: availableSpace,
                  },
                });

                changeStateModal(false);
              }}>
                Si, quiero habilitarla
              </Button>

              <Button onClick={() => changeStateModal(!estatusModal)} className="cancel-button">No, mejor no</Button>
            </div>
          </div>
        </div>
      </Modal >

      <Message data={message} ref={message.open} />
    </div >
  )
}